export enum PrestationTypeFilterEnum {
  AM = 'am',
  PM = 'pm',
  NIGHT = 'night',
  MA = 'ma',
  ABSENCE = 'absence',
  COUNTED = 'counted',
  DISPONIBILITY = 'disponibility',
  WE = 'we'
}

export const ALL_PRESTATION_TYPE_FILTER = [
  PrestationTypeFilterEnum.AM,
  PrestationTypeFilterEnum.PM,
  PrestationTypeFilterEnum.NIGHT,
  PrestationTypeFilterEnum.MA,
  PrestationTypeFilterEnum.ABSENCE,
  PrestationTypeFilterEnum.COUNTED,
  PrestationTypeFilterEnum.DISPONIBILITY,
  PrestationTypeFilterEnum.WE
];

export interface PrestationTypeFilterInterface {
  am: boolean,
  pm: boolean,
  night: boolean,
  ma: boolean,
  absence: boolean,
  counted: boolean,
  disponibility: boolean
}

export const VALUE_PRESTATION_TYPE_FILTER = {
  am: false,
  pm: false,
  night: false,
  ma: false,
  absence: false,
  counted: false,
  disponibility: false
}
